<template>
    <div class="touch-for-installers-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="box _gradient-bar">
            <div class="box-1">
                <h1>
                  Maximise enquiries and sales by using
                  Vendor across your whole business.
                </h1>
                <p>
                  Vendor is standalone and not linked to any Fabricator. Vendor comes
                  with industry standard data, rules & imagery.
                </p>
              <p>
                <a class="btn-primary" href="/touch-store" target="_blank">
                  Get 1 Month Free
                </a>
                <a class="btn-primary" href="/web-support/explore-touch-demo">
                  View Demo
                </a>
              </p>
                <div class="image">
                    <img src="/images/touch-for-installers-page-01.png">
                </div>
            </div>
          <div class="box-2">
            <div class="content align-center">
              <h1 class="mb-0 mt-0">
                First month FREE, Limited Offer
              </h1>
              <p class="txt-sm">
                Price after first month £75.00 p/month. All prices exclude VAT, Cancel at any time to stop future charges.
              </p>
            </div>
          </div>
          <div class="box-4">
            <div class="col-info">
              <div>
                <h1>
                  Two Modes In One
                </h1>
                <p>
                  Vendor is an all encompassing piece of software that allows you to generate enquiries, quote and survey and then request a price from multiple suppliers.
                </p>
              </div>
            </div>
            <div class="col-image">
              <img src="/images/touch-for-installers-page-02.png">
            </div>
          </div>
          <div class="box-5">
              <div class="col">
                <div class="box">
                  <div class="image">
                    <img src="/images/touch-for-installers-page-03.png">
                  </div>
                  <div class="content">
                    <h1>
                      Mode 1
                    </h1>
                    <ul>
                      <li>
                        Generate warm enquiries online
                      </li>
                      <li>
                        Simple and concise product questions
                      </li>
                      <li>
                        Ability to turn price on or off
                      </li>
                      <li>
                        Deploy to your current website
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            <div class="col">
              <div class="box">
                <div class="image">
                  <img src="/images/touch-for-installers-page-04.png">
                </div>
                <div class="content">
                  <h1>
                    Mode 2
                  </h1>
                  <ul>
                    <li>
                      Convert enquiries to quotes
                    </li>
                    <li>
                      Technical questions for finalising a quote
                    </li>
                    <li>
                      Live real time pricing
                    </li>
                    <li>
                      For use in showroom, office or customers home
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="box-6">
            <div class="col-info">
              <div>
                <h1>
                  Product data
                  from the experts
                </h1>
                <p>
                  Vendor data comes from the master datasets provided by the industry's leading profile suppliers. This is what makes Vendor the most flexible and advanced quoting system on the market. It gives you access to an unrivalled list of products, advanced shapes and designs but with inbuilt knowledge of production limitations. Have your own affordable quoting system, without having to worry about developing their own product data and pricing structures.
                </p>
              </div>
            </div>
            <div class="col-image">
              <img src="/images/touch-for-installers-page-05.png">
            </div>
          </div>
          <div class="box-7">
            <div class="col">
              <div class="col-inner">
                <img src="/images/touch-for-installers-page-06.png">
                <h4>
                  Upvc Products
                </h4>
                <ul>
                  <li>Composite Doors</li>
                  <li>Casement Windows</li>
                  <li>Flush Sash Windows</li>
                  <li>Tilt & Turn Windows</li>
                  <li>Vertical Sliding Windows</li>
                  <li>Bay Windows</li>
                  <li>Bow Windows</li>
                  <li>Single Doors</li>
                  <li>French Doors</li>
                  <li>Bi Folding Door</li>
                  <li>Sliding Patio Door</li>
                </ul>
              </div>
            </div>
            <div class="col">
              <div class="col-inner">
                <img src="/images/touch-for-installers-page-07.png">
                <h4>
                  Timber Products
                </h4>
                <ul>
                  <li>Casement Windows</li>
                  <li>Tilt & Turn Windows</li>
                  <li>Sash Windows</li>
                  <li>Single Doors</li>
                  <li>Solid Doors</li>
                  <li>Double Doors</li>
                  <li>Coupled Products</li>
                </ul>
              </div>
            </div>
            <div class="col">
              <div class="col-inner">
                <img src="/images/touch-for-installers-page-08.png">
                <h4>
                  Aluminium Products
                </h4>
                <ul>
                  <li>Casement Windows</li>
                  <li>Single Doors</li>
                  <li>Double Doors</li>
                  <li>Patio Doors</li>
                  <li>Bi-Fold Doors</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="box-8">
            <div class="col-image">
              <img src="/images/touch-for-installers-page-09.png">
            </div>
            <div class="col-info">
              <div>
                <h1>
                  Create your own pricing
                  to automatically
                  price in the field
                </h1>
                <p>
                  Save time while in the field or the office and automatically calculate your selling price on every job. Our new extensive pricing allows you to price every product individually to help you save time and price more accurately.
                </p>
                <p>
                  Price each product/material<br>
                  Price by size<br>
                  Set your own glass and hardware and colour prices<br>
                  Price override available<br>
                  Real time pricing on your sales & survey designer<br>
                  Optional live pricing on your website designer
                </p>
              </div>
            </div>
          </div>
          <div class="box-9">
            <div class="col-info">
              <div>
                <h1>
                  Apply additions and
                  extras to your quotes
                </h1>
                <p>
                  Create your own extras lists to cater for additional survey questions, fitting and general extra items.
                </p>
                <p>
                  Name each extra<br>
                  Add sub options to each extra<br>
                  Add a unit of measure for each extra: length, width, height, area, perimeter, volume, fitting area<br>
                  Attribute a cost<br>
                  Upload an image to easily identify your extra<br>
                  Show or hide extras on quotes
                </p>
              </div>
            </div>
            <div class="col-image">
              <img src="/images/touch-for-installers-page-10.png">
            </div>
          </div>
          <div class="box-10">
            <div class="col-image">
              <img src="/images/touch-for-installers-page-11.png">
            </div>
            <div class="col-info">
              <div>
                <h1>
                  Present with Virtual Home
                </h1>
                <p>
                  Unlike standard visualisers, Virtual Home allows you to upload images of every façade of your property; both from inside and outside. Then, any products processed in the TOUCH quote or enquiry can be superimposed on any house image and manually positioned. The system retains knowledge of every step so any changes to the specification instantly appear on the Virtual Home images. The Virtual Home images can then be added to any quote documentation or experience.
                </p>
              </div>
            </div>
          </div>
          <div class="box-11">
            <div class="col">
              <div class="col-inner">
                <div class="icon">
                  <i class="fal fa-image-polaroid"></i>
                </div>
                <strong>
                  Import multiple photos
                </strong>
                <p>
                  Unlike most visualisers Virtual Home has the facility for customers to upload multiple photographs showing different sides and views of their home.
                </p>
              </div>
            </div>
            <div class="col">
              <div class="col-inner">
                <div class="icon">
                  <i class="fal fa-repeat-alt"></i>
                </div>
                <strong>
                  See internal or external view
                </strong>
                <p>
                  Customers can also upload internal and external photographs of the home, choosing to use internal or external product images for realistic and accurate representations.
                </p>
              </div>
            </div>
            <div class="col">
              <div class="col-inner">
                <div class="icon">
                  <i class="fal fa-male"></i>
                </div>
                <strong>
                  Present to customers
                </strong>
                <p>
                  Not only will customers be able to create visualisations on your website version of Vendor but you can also create them on their behalf using the sales and survey designer.
                </p>
              </div>
            </div>
            <div class="col">
              <div class="col-inner">
                <div class="icon">
                  <i class="fal fa-envelope-open-text"></i>
                </div>
                <strong>
                  Visualisations saved to quotes
                </strong>
                <p>
                  Once you or the customer has created a visualisation this is then saved to a quote or enquiry and can be accessed in your Vendor management area.
                </p>
              </div>
            </div>
          </div>
          <div class="box-12">
            <div class="col-info">
              <div>
                <h1>
                  Sell without home visits
                </h1>
                <p>
                  Vendor is the ideal tool for online sales presentations, allowing for shared quote generation and online home visualisations to enhance the customer experience.
                </p>
                <p>
                  Looking for more detail on how vendor prices Register for full access to the demo.
                </p>
              </div>
            </div>
            <div class="col-image">
              <img src="/images/touch-for-installers-page-12.png">
            </div>
          </div>
          <div class="box-13">
            <div class="col-image">
              <img src="/images/touch-for-installers-page-13.png">
            </div>
            <div class="col-info">
              <div>
                <h1>
                  Generate professional,
                  branded paperwork
                </h1>
                <p>
                  This is the email that a customer will automatically receive once they make an enquiry via the website designer. This will be branded with your logo.
                </p>
              </div>
            </div>
          </div>
          <div class="box-14">
            <div class="col-info">
              <div>
                <h1>
                  Add Extra Users
                </h1>
                <p>
                  You can add your own staff users; this could be an installer or surveyor out in the field or an office based staff member to create and process enquiries and quotes. This is an additional cost, prices can be viewed once you register for the TOUCH Store.
                </p>
              </div>
            </div>
            <div class="col-image">
              <img src="/images/touch-for-installers-page-14.png">
            </div>
          </div>
          <div class="box-15">
            <div class="col-info">
              <div>
                <h1>
                  FREE TOUCH Guide
                  for Installers
                </h1>
                <p>
                  For more information on TOUCH for your business  please download a complete guide.
                </p>
                <div>
                  <a class="btn-primary"href="/documents/vendor_how_to_guide.pdf" target="_blank">
                    Download
                  </a>
                </div>
              </div>
            </div>
            <div class="col-image">
              <img src="/images/touch-for-installers-page-15.png">
            </div>
          </div>
          <div class="box-16">
            <div class="col">
              <div class="col-inner">
                <div class="image">
                  <img src="/images/touch-for-installers-page-16.png">
                </div>
                <div class="content">
                  <h1>
                    Vendor Sales & Support
                  </h1>
                  <p>
                    Call us now for more information on
                    0800&nbsp;059&nbsp;9705

                  </p>
                  <a class="btn-primary-outline" @click.stop.prevent="enquiry_box_open = true">
                    Make an Enquiry
                  </a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="col-inner">
                <div class="image">
                  <img src="/images/touch-for-installers-page-17.png">
                </div>
                <div class="content">
                  <h1>
                    Play with the&nbsp;demo
                  </h1>
                  <p>
                    Click to register for the store
                    and play with our free Vendor demo
                  </p>
                  <a class="btn-primary-outline" href="/web-support/explore-touch-demo">
                    Get the Demo
                  </a>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="col-inner">
                <div class="image">
                  <img src="/images/touch-for-installers-page-18.png">
                </div>
                <div class="content">
                  <h1>
                    Get 1 month FREE
                  </h1>
                  <p>
                    Register today and get one
                    month&nbsp;completely&nbsp;free
                  </p>
                  <a class="btn-primary-outline" href="/touch-store" target="_blank">
                    Get 1 month free
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Thank you for your interest</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent
                        a notification when you receive a reply.
                    </div>
                    <div class="mb-6">
                        If you would like to provide some more information you can edit the message below.
                    </div>
                    <strong class="block pl-2 pb-1">Your Message</strong>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'system_types',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I am interested in purchasing Touch Vendor, could I be sent some further information, thank you.',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 28,
                'message': this.enquiry_message,
            })
                .then((response) => {

                  gtag('event', 'enquiry_made', {
                    'event_category': 'enquiries',
                    'event_label': 'Touch enquiry',
                    'value': 'Touch enquiry',
                  });

                    this.sending = false;
                    Swal.fire({
                        title: 'Enquiry Sent',
                        icon: 'success',
                        text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
                    });
                });
        },
    },
};
</script>
